// extracted by mini-css-extract-plugin
export default {"button":"TwoFactorAuthButton_button__3Ox7E","badge":"TwoFactorAuthButton_badge__jZT47","badgePending":"TwoFactorAuthButton_badgePending__d+OpY"};